module.exports = __webpack_public_path__ + "static/media/fork.103adba4.svg";